/**
 * This file is auto-generated. Any modifications will be
 * overwritten by the generate-icon npm script.
 */
import React from 'react';
import { SvgIcon } from "../shared/SvgIcon";
var EyeFillIcon = function EyeFillIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("path", {
    d: "M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.67876 7.44513C7.26462 6.16051 9.41173 5 12 5C14.5883 5 16.7354 6.16051 18.3213 7.44513C19.9084 8.73074 21.0048 10.1969 21.5177 10.9545C21.9477 11.5898 21.9477 12.4102 21.5177 13.0455C21.0048 13.8031 19.9084 15.2693 18.3213 16.5549C16.7354 17.8395 14.5883 19 12 19C9.41173 19 7.26462 17.8395 5.67876 16.5549C4.09166 15.2693 2.99517 13.8031 2.48236 13.0455C2.05227 12.4102 2.05227 11.5898 2.48236 10.9545C2.99517 10.1969 4.09166 8.73074 5.67876 7.44513ZM12 17C14.7614 17 17 14.7614 17 12C17 9.23858 14.7614 7 12 7C9.23858 7 7 9.23858 7 12C7 14.7614 9.23858 17 12 17Z"
  }));
};
export default EyeFillIcon;